
import React from 'react';
import { Button } from './button';
import { Check, X } from 'lucide-react';

interface PricingFeature {
  text: string;
  included: boolean;
}

interface PricingBadge {
  text: string;
}

interface PricingCardProps {
  title: string;
  price: string;
  description: string;
  features?: PricingFeature[];
  popular?: boolean;
  ctaText?: string;
  ctaLink?: string;
  setupFee?: string;
  badges?: PricingBadge[];
  hideMonthly?: boolean;
}

const PricingCard: React.FC<PricingCardProps> = ({
  title,
  price,
  description,
  features = [],
  popular = false,
  ctaText = "Contact for Info",
  ctaLink = "/contact",
  setupFee,
  badges = [],
  hideMonthly = false
}) => {
  return (
    <div className={`h-full rounded-xl overflow-hidden border ${popular ? 'border-primary shadow-lg' : 'border-astrem-gray-200'}`}>
      {popular && (
        <div className="bg-primary py-1.5 text-white text-center text-sm font-medium">
          Most Popular
        </div>
      )}
      
      <div className="p-6 md:p-8 bg-white h-full flex flex-col">
        <h3 className="text-xl font-medium text-astrem-black mb-3">{title}</h3>
        
        <div className="mb-2">
          <span className="text-lg font-medium text-astrem-black">Contact for Custom Quote</span>
        </div>
        
        {badges.length > 0 && (
          <div className="flex flex-wrap gap-2 mb-4">
            {badges.map((badge, index) => (
              <span key={index} className="inline-block px-2 py-1 bg-primary/10 text-primary text-xs rounded-full">
                {badge.text}
              </span>
            ))}
          </div>
        )}
        
        <p className="text-astrem-gray-600 mb-6">{description}</p>
        
        {features.length > 0 && (
          <div className="space-y-3 mb-8 flex-grow">
            {features.map((feature, index) => (
              <div key={index} className="flex items-start">
                {feature.included ? (
                  <div className="mr-3 mt-0.5 rounded-full p-1 bg-green-100 text-green-600">
                    <Check className="h-3.5 w-3.5" />
                  </div>
                ) : (
                  <div className="mr-3 mt-0.5 rounded-full p-1 bg-red-100 text-red-500">
                    <X className="h-3.5 w-3.5" />
                  </div>
                )}
                <span className={feature.included ? 'text-astrem-gray-700' : 'text-astrem-gray-400'}>
                  {feature.text}
                </span>
              </div>
            ))}
          </div>
        )}
        
        <Button asChild variant={popular ? "default" : "outline"} className={`w-full rounded-lg ${popular ? 'bg-primary hover:bg-primary/90' : ''}`}>
          <a href={ctaLink}>
            {ctaText}
          </a>
        </Button>
      </div>
    </div>
  );
};

export default PricingCard;
